import { render, staticRenderFns } from "./Carousel4.vue?vue&type=template&id=31c25bce&scoped=true&"
import script from "./Carousel4.vue?vue&type=script&lang=js&"
export * from "./Carousel4.vue?vue&type=script&lang=js&"
import style0 from "./Carousel4.vue?vue&type=style&index=0&id=31c25bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c25bce",
  null
  
)

export default component.exports